import styled from 'styled-components';
import DropDown from '@/trio-ui/Dropdown';

export const CustomDropdown = styled(DropDown)`
  width: 60px;
  margin-bottom: 0;

  &:not(&:last-of-type) {
    margin-bottom: 0;
  }

  label {
    display: none;
  }

  div {
    max-width: initial;
  }

  span:nth-of-type(1) {
    margin-top: -1px;
  }
`;
